export default "__VITE_ASSET__B_Yl$jIb__"